import React from "react";
import { Link } from "react-router-dom";
import it from "@/locales/it.json";

// Thank you page is Italian only per requirements.
export default function ThankYou() {
  return (
    <main
      className="min-h-[80vh] flex items-center justify-center"
      style={{ backgroundColor: "#FAF8F5", color: "#1C1917" }}
      data-testid="thank-you-page"
    >
      <div className="mx-auto max-w-xl px-6 lg:px-10 py-20 text-center">
        <div className="font-mono text-xs uppercase tracking-[0.25em]" style={{ color: "#8A6E1E" }}>
          Berqelo · Riserva Privata
        </div>
        <h1 className="mt-6 font-serif text-4xl lg:text-5xl leading-tight tracking-tight" style={{ color: "#1C241C" }}>
          Grazie. La tua richiesta è arrivata a Firenze.
        </h1>
        <p className="mt-8 font-sans text-base leading-relaxed" style={{ color: "#3F3B36" }}>
          Abbiamo ricevuto la tua iscrizione alla lista privata Berqelo. Ti scriveremo personalmente dal nostro
          indirizzo <span style={{ color: "#1C241C" }}>riserva@berqelo.com</span> quando la Riserva 2026 sarà pronta
          per essere consegnata. Nel frattempo, la tua richiesta rimane custodita nel nostro registro cartaceo
          numerato, senza terze parti, senza pubblicità, senza rinnovi silenziosi.
        </p>
        <p className="mt-6 font-sans text-sm" style={{ color: "#57534E" }}>
          Per qualunque necessità, la casa è raggiungibile all'indirizzo Via de' Tornabuoni 12, 50123 Firenze.
        </p>
        <div className="mt-12">
          <Link
            to="/"
            data-testid="thank-you-back-home"
            className="inline-block rounded-sm px-6 py-3 font-sans text-sm tracking-wide"
            style={{ backgroundColor: "#2D3B2D", color: "#FAF8F5" }}
          >
            Torna alla Home
          </Link>
        </div>
        <div className="mt-16 font-mono text-[11px] uppercase tracking-[0.25em]" style={{ color: "#8A8478" }}>
          Berqelo Società Agricola S.r.l. · P.IVA IT09847320961 · Firenze
        </div>
      </div>
    </main>
  );
}
